import {
  LOCAL_STORAGE_ACCESS_TOKEN,
  LOCAL_STORAGE_REFRESH_TOKEN,
} from "../../../utils/constants";
import { fetchUserInfo } from "../user/asyncThunk";
import { sendCode, logout, refresh, verifyEmail } from "./asyncThunks";

export const sendCodeBuilder = (builder) => {
  builder.addCase(sendCode.pending, (state) => {
    state.loginPending = true;
  });
  builder.addCase(sendCode.fulfilled, (state, action) => {
    const data = action.payload;

    if (data?.accessToken) {
      state.token = data.accessToken;
      state.loggedIn = true;
    }
    state.loginPending = false;
  });
  builder.addCase(sendCode.rejected, (state) => {
    state.loginPending = false;
  });
};

export const fetchUserInfoBuilder = (builder) => {
  builder.addCase(fetchUserInfo.fulfilled, (state) => {
    state.loggedIn = true;
  });
  builder.addCase(fetchUserInfo.rejected, (state) => {
    state.loggedIn = false;
  });
};

export const logoutBuilder = (builder) => {
  builder.addCase(logout.pending, (state) => {
    state.loggedIn = false;
  });
  builder.addCase(logout.fulfilled, () => {
    localStorage.removeItem(LOCAL_STORAGE_ACCESS_TOKEN);
    localStorage.removeItem(LOCAL_STORAGE_REFRESH_TOKEN);
  });
  builder.addCase(logout.rejected, (state) => {
    localStorage.removeItem(LOCAL_STORAGE_ACCESS_TOKEN);
    localStorage.removeItem(LOCAL_STORAGE_REFRESH_TOKEN);
  });
};

export const refreshBuilder = (builder) => {
  builder.addCase(refresh.fulfilled, (state, action) => {
    const { accessToken } = action.payload;
    state.loggedIn = true;
    state.token = accessToken;
  });
};

export const verifyEmailBuilder = (builder) => {
  builder.addCase(verifyEmail.pending, (state) => {
    state.verifyEmailPending = true;
  });
  builder.addCase(verifyEmail.fulfilled, (state, { payload }) => {
    state.verifyEmailPending = false;
    const { accessToken } = payload;

    state.token = accessToken;
    state.loggedIn = true;
  });
  builder.addCase(verifyEmail.rejected, (state) => {
    state.verifyEmailPending = false;
  });
};
